/* eslint-disable no-undef */
const { REACT_APP_SCAMS_ENV, REACT_APP_API_BASE_URL, REACT_APP_SCAMS_REPORT_ASSETS_BASE_URL } =
  process.env;

export const config = {
  SCAMS_ENV: REACT_APP_SCAMS_ENV || 'dev',
  API_BASE_URL: REACT_APP_API_BASE_URL || 'http://localhost:8080',
  SCAMS_REPORT_ASSETS_BASE_URL:
    REACT_APP_SCAMS_REPORT_ASSETS_BASE_URL || 'https://chat.scams.report',
};
